import { EmptyState, Spinner } from '@nexo/ui';
import { Pin } from 'lucide-react';
import { usePins } from '../../lib/queries';
import { MessageItem } from './MessageItem';
import { useTranslation } from 'react-i18next';

/** Pinned messages of the current conversation. */
export function PinsPanel({ channelId }: { channelId: string | undefined }) {
  const { t } = useTranslation();
  if (!channelId) {
    return (
      <EmptyState
        icon={<Pin className="size-6" />}
        title={t('Abre una conversación')}
        description={t('Aquí verás sus mensajes fijados.')}
      />
    );
  }
  return <Pins channelId={channelId} />;
}

function Pins({ channelId }: { channelId: string }) {
  const pins = usePins(channelId);
  const { t } = useTranslation();
  if (pins.isPending) {
    return (
      <div className="flex flex-1 items-center justify-center text-muted">
        <Spinner />
      </div>
    );
  }
  if (!pins.data?.length) {
    return (
      <EmptyState
        icon={<Pin className="size-6" />}
        title={t('Nada fijado todavía')}
        description={t(
          'Fija los mensajes importantes (decisiones, enlaces, fechas) para tenerlos siempre a mano.',
        )}
      />
    );
  }
  return (
    <div className="scrollbar-thin min-h-0 flex-1 overflow-y-auto pb-3 [&_article]:px-4">
      {pins.data.map((message) => (
        <MessageItem key={message.id} message={message} compact={false} inThread />
      ))}
    </div>
  );
}
